// @flow
import React from "react";
import LegalPageComponent, { type LegalPageType } from "../../components/LegalPage";
import PageLayout from "../../components/PageLayout";

type LegalPagePortalProps = {
  type: LegalPageType
};

const LegalPagePortal = ({ type }: LegalPagePortalProps) => (
  <PageLayout>
    <LegalPageComponent type={type} />
  </PageLayout>
);

export default LegalPagePortal;
